import React, {useCallback, useEffect, useState, useRef} from "react";
import "./singleRangeSlider.css";

const SingleRangeSlider = ({min, max, onChange, changeMin, changeMax, maxInit}) => {
    const [minVal, setMinVal] = useState(min);
    const [maxVal, setMaxVal] = useState(maxInit);
    const minValRef = useRef(min);
    const maxValRef = useRef(max);
    const range = useRef(null);

    // Convert to percentage
    const getPercent = useCallback(
        (value) => Math.round(((value - min) / (max - min)) * 100),
        [min, max]
    );

    // Set width of the range to decrease from the left side
    useEffect(() => {
        const minPercent = getPercent(minVal);
        const maxPercent = getPercent(maxValRef.current);

        if (range.current) {
            range.current.style.left = `${minPercent}%`;
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
    }, [minVal, getPercent]);

    // Set width of the range to decrease from the right side
    useEffect(() => {
        const minPercent = getPercent(minValRef.current);
        const maxPercent = getPercent(maxVal);

        if (range.current) {
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
    }, [maxVal, getPercent]);

    // Get min and max values when their state changes
    useEffect(() => {
        onChange({min: minVal, max: maxVal});
    }, [minVal, maxVal, onChange]);

    return (
        <div className="container">
            <br/>
            <div className="single-range-slider-wrapper">
                <input
                    type="range"
                    min={min}
                    max={max}
                    value={maxVal}
                    onChange={(event) => {
                        const value = Math.max(Number(event.target.value), minVal + 1);
                        setMaxVal(value);
                        maxValRef.current = value;
                        changeMax(value);
                    }}
                    className="single-thumb single-thumb--right"
                />

                <div className="single-slider">
                    <div className="single-slider__track"/>
                    <div ref={range} className="single-slider__range"/>
                    <div className="single-slider__left-value">{minVal}</div>
                    <div className="single-slider__right-value">{maxVal}</div>
                </div>
            </div>

            <br/>
            <br/>
        </div>
    );
};

// SingleRangeSlider.propTypes = {
//     min: PropTypes.number.isRequired,
//     // max: PropTypes.number.isRequired,
//     onChange: PropTypes.func.isRequired
// };

export default SingleRangeSlider;
